import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import './App.css';

import { ErrorBoundary } from "./common/ErrorBoundary";

import { Footer } from './common/Footer';

import { Home } from './pages/Home';
import { Program } from './pages/Program';
import { Subject } from './pages/Subject';
import { Coaching } from './pages/Coaching';
import { Purchase } from './pages/Purchase';

import LandingPage from './pages/LandingPage';

import { GeneralNotFound } from './common/NotFound';

import { useUser, useUserUpdate } from "./context/UserContext";
import { UserValidationPolling } from "./utilities/polling"

import PageViewTracker from './components/analytics/PageViewTracker';

import PrivacyPolicy from './components/business/PrivacyPolicy';
import { BusinessPage, BusinessPageType } from './components/business/BusinessPage';
import Portfolio from './pages/Portfolio';





function App() {


  /* TODO: COME BACK TO -- Right now won't invalidate User Sessions from Server -- Issue with Client calling this constantly or when use [user] as dependency, seems to change unexpectedly causing more intervals to be created/removed, and then when log in would randomly log me out
  const { user } = useUser();
  const { removeUser } = useUserUpdate();

  useEffect( () => {

    const pollValidation = async () => {
      const userValid = await UserValidationPolling.checkUserValidation();

      if( !userValid ) {
        console.log("USER VALID", userValid, "POLLING INTERVAL", pollValidationIntervalId);
        clearInterval( pollValidationIntervalId );

        removeUser();
      }
    }
    const pollValidationIntervalId = setInterval( pollValidation, UserValidationPolling.USER_POLLING_INTERVAL );

    return () => {
      console.log("CLEARING INTERVAL WITH ID", pollValidationIntervalId);
      clearInterval( pollValidationIntervalId );
    }
  }, []);
  */

  return (
    <ErrorBoundary>
      <div className="app">
        <BrowserRouter>

          <PageViewTracker />

          <Routes>
            {/* Catch-All Route for 404 */}
            {/* TODO: Not clear if best place put this, seems should go last, but that didn't work */}
            <Route path="*" element={<GeneralNotFound />} />

            {/*<Client-Side Redirect, no call to Server when "Navigate"*/}
            <Route path="/" element={<Navigate to="/product" replace />} />
            <Route path="/product" element={<Home />} />

            {/*<Route path="/landing/:category/:subjectType/:subjectSelector/:programSelector/:featureSelector" element={<LandingPage />} />*/}
            <Route path="/landing/*" element={<LandingPage />} />

            <Route path="/content/:type/:subjectSelector/:programSelector" element={<Subject />} />
            <Route path="/content/:type/:subjectSelector/:programSelector/:featureSelector" element={<Program />} />

            {/*<Route path="/content/coaching" element={<Coaching />} />*/}
            <Route path="/content/coaching/:engagementSelector/:optionSelector" element={<Coaching />} />
            {/* INVALID ROUTE - NOT SUPPORT HASH <Route path="/content/coaching/:engagementName#option" element={<Coaching />} /> */}

            <Route path="/purchase" element={<Purchase />} />

            <Route path="/business/privacy-policy" element={<BusinessPage businessPageType={BusinessPageType.PRIVACY_POLICY} />} />
            <Route path="/business/terms-of-use" element={<BusinessPage businessPageType={BusinessPageType.TERMS_OF_USE} />} />
            <Route path="/business/about-us" element={<BusinessPage businessPageType={BusinessPageType.ABOUT_US} />} />

            <Route path="/portfolio" element={<Portfolio />} />
          </Routes>

          <Footer />
        </BrowserRouter>
      </div> {/* TODO: Keep Footer in here on App level? */}
    </ErrorBoundary>
  );
}




export default App;
